<template>
  <div class="member-content">
    <div class="group">
      <span>医生团队</span>
      <span>（{{ doctorArr.length ? doctorArr.length : 0 }}人）</span>
    </div>
    <div class="addPerson flex flex-middle flex-center" @click="addPeoplePopup()">
      <img src="@/assets/img/chengyuan.png" />
      <span>添加新成员</span>
    </div>
    <div class="personList">
      <div class="flex flex-middle personList-item" v-for="(item, index) in doctorArr" :key="index">
        <img :src="item.caa_Picture_address ? item.caa_Picture_address : item.pic" class="touxiang" />
        <div class="info">
          <div>{{ item.caa_full_name ? item.caa_full_name : '' }}</div>
          <div class="small">{{ item.caa_phone_number ? item.caa_phone_number : '' }}</div>
        </div>
        <el-button circle icon="el-icon-edit" @click="editItem(item)" />
        <el-button circle icon="el-icon-delete" @click="deleteItem(item)" />
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="50%" top="240px">
      <el-form ref="patientForm" :model="patientForm" :rules="rules" label-width="120px">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="patientForm.name" placeholder="请输入医生姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-radio-group v-model="patientForm.sex">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-bottom: 30px" label="电话：" prop="phone">
          <el-input v-model="patientForm.phone" placeholder="请输入医生手机号"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 30px" label="头像：">
          <el-upload
            ref="my-upload"
            action="#"
            :http-request="httpRequest"
            list-type="picture-card"
            :limit="1"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :auto-upload="false"
            :file-list="hxFileList"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">头像只能上传1张，且不超过2M</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="cancelAddDoctor">取消</el-button>
        <el-button @click="submitForm" type="primary">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';
import md5 from 'js-md5';
import { uploadImage } from '../../../../api/index';
export default {
  name: 'DoctorMngr',
  data() {
    var checkphone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号'));
      } else if (!this.isCellPhone(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('输入正确格式的手机号!'));
      } else {
        callback();
      }
    };
    return {
      clinicInfo: {},
      hxurl: 'https://picture.hwason.cn/image/png/90974386962065088.png',
      hxFileList: [], //上传组件内
      dialogImageUrl: '', //上传组件内
      dialogVisible: false, //上传组件内

      dialogTitle: '新增医生账号',
      uploadImageSrc: '', //最终上传图片地址
      visible: false, //弹出框
      patientForm: {
        id: '',
        name: '',
        sex: '男',
        phone: ''
      },
      rules: {
        //  中健前端 耿鹏：手机号 和验证码 仍在哪里 别动 别校验 先以这三个为主
        phone: [{ required: true, validator: checkphone, trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }]
      },
      doctorArr: [
        {
          id: '123456',
          caa_Picture_address: require('@/assets/img/userImg.png'),
          caa_full_name: '何医生',
          sex: 'male',
          caa_phone_number: '13388885555'
        }
      ]
    };
  },

  created() {
    this.clinicInfo = JSON.parse(sessionStorage.user);
    this.getDoctorList();
    // let obj = new Object();
    // obj.url = 'https://picture.hwason.cn/image/png/90974386962065088.png';
    // this.hxFileList.push(obj);
  },
  methods: {
    httpRequest(data) {
      // let _this = this;
      // let rd = new FileReader(); // 创建文件读取对象
      // let file = data.file;
      // rd.readAsDataURL(file); // 文件读取装换为base64类型
      // rd.onloadend = function (e) {
      //   _this.dialogImageUrl = this.result; // this指向当前方法onloadend的作用域
      // };
    },
    // 删除图片
    handleRemove(file) {
      // const index = this.fileList.findIndex((x) => x.uid === file.uid);
      // this.uploadImageList.splice(index, 1);
      // this.fileList.splice(index, 1);
    },
    //上传图片
    handleChange(file, fileList) {
      const that = this;
      const isImg = file.size / 1024 / 1024 < 2;
      if (!isImg) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      let formdata = new FormData();
      formdata.append('file', file.raw);
      formdata.append('type', file.raw.type);
      uploadImage(formdata).then((res) => {
        if (res.success) {
          that.$message.success('图片选择成功');
          that.uploadImageSrc = res.data;
        } else {
          that.$message.error('图片选择失败，请删除后重新上传');
        }
      });
    },
    // 放大图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 获取医生团队
    getDoctorList() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.cal_code //诊所编码
      };
      const params = {
        token: clinicInfo.token,
        datatab: 'a508ZL2TozrML1xaO2mS55rf+cKrtW29lfgAEQGKiFOnKXagicxvKYOyCcg', //对应表名
        select: 'abcfitCqWCvcwFMy2jCS42PRTUFb8vaaeZpUaSYI', //需要字段的名字
        obgb: '5cd5bajPlsaLb5TmbMERjd3iUbYrCWMegPgjD8Drw3tipwFbOwpXOKAdvcszeJR+X+lKl7+jJFJMSITsnd+ghduVrFqb/lzAWbk', //不动
        LIKE: 'nl',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getkehulbapi.php', params)
        .then((res) => {
          that.doctorArr = res;
          // console.log('医生列表：', that.doctorArr);
        })
        .catch((err) => {});
    },
    // 添加弹窗
    addPeoplePopup() {
      this.dialogTitle = '新增医生账号';
      this.visible = true;
    },
    // 增加医生确定按钮
    submitForm() {
      // this.visible = false;
      this.$refs.patientForm.validate(async (valid) => {
        if (valid) {
          if (this.dialogTitle === '新增医生账号') {
            await this.addDoctor();
          } else if (this.dialogTitle === '修改医生账号') {
            await this.editDoctor();
          }
        } else {
          return false;
        }
      });
    },
    //增加医生
    async addDoctor() {
      const that = this;
      const password ='Hs@'+ that.clinicInfo.cal_code + that.patientForm.phone.substr(-4);//增加账号密码
      let dataP = {
        cal_code: that.clinicInfo.cal_code, //诊所编码
        cal_name: that.clinicInfo.cal_name,
        caa_full_name: that.patientForm.name,
        caa_Gender: that.patientForm.sex,
        caa_phone_number: that.patientForm.phone,
        caa_Login_account: that.patientForm.phone,
        caa_Login_password: md5(password),
        caa_Picture_address: that.uploadImageSrc
      };
      const params = {
        token: that.clinicInfo.token,
        datatab: '54a6m146/YT7Tqi2D+z2puKEEr5pJ6Axg8i0LR9KpsdBkyMueRt2JCWO/yI', //对应表名
        data: JSON.stringify(dataP)
      };
      await request
        .post('/server/setkehuzlapi.php', params)
        .then((res) => {
          if (res.IsOk === 'success') {
            that.$message.success('恭喜，新增账号成功');
            that.$refs.patientForm.resetFields();
            that.visible = false;
            that.getDoctorList();
            that.patientForm.id = '';
            that.patientForm.name = '';
            that.patientForm.sex = '男';
            that.patientForm.phone = '';
            that.uploadImageSrc = '';
            that.hxFileList = [];
          } else {
            that.$message.error('抱歉，新增账号失败');
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，新增账号失败');
        });
    },
    //修改医生
    async editDoctor() {
      const that = this;
      let dataP = {
        cal_code: that.clinicInfo.cal_code, //诊所编码
        cal_name: that.clinicInfo.cal_name,
        caa_full_name: that.patientForm.name,
        caa_Gender: that.patientForm.sex,
        caa_phone_number: that.patientForm.phone,
        caa_Login_account: that.patientForm.phone,
        caa_Picture_address: that.uploadImageSrc,
        id: that.patientForm.id
      };
      const params = {
        token: that.clinicInfo.token,
        datatab: '40c3JatC6GRA84QacElj8SN24CU0pHSiVjvNY4khonUbvV6ggsjlvOOjn0I', //对应表名
        data: JSON.stringify(dataP)
      };
      await request
        .post('/server/setkehuzlapi.php', params)
        .then((res) => {
          if (res.IsOk === 'success') {
            that.$message.success('恭喜，修改成功');
            that.$refs.patientForm.resetFields();
            that.visible = false;
            that.getDoctorList();
            that.patientForm.id = '';
            that.patientForm.name = '';
            that.patientForm.sex = '男';
            that.patientForm.phone = '';
            that.uploadImageSrc = '';
            that.hxFileList = [];
          } else {
            that.$message.error('抱歉，修改失败');
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，修改失败');
        });
    },
    //编辑医生
    editItem(val) {
      console.log('编辑：：', val);
      const that = this;
      that.dialogTitle = '修改医生账号';
      that.patientForm.id = val.id;
      that.patientForm.name = val.caa_full_name;
      that.patientForm.sex = val.caa_Gender;
      that.patientForm.phone = val.caa_phone_number;
      that.uploadImageSrc = val.caa_Picture_address;
      // 上传图片组件回显
      let obj = new Object();
      obj.url = val.caa_Picture_address;
      that.hxFileList.push(obj);
      // Object.assign(this.form, val);
      that.visible = true;
    },
    // 删除医生账号
    deleteItem(val) {
      const that = this;
      this.$confirm(`确定要删除"${val.caa_full_name}"吗？`, '提示')
        .then(() => {
          that.deleteDoctor(val.id);
        })
        .catch(() => {});
    },
    // 删除医生
    async deleteDoctor(ids) {
      const that = this;
      const params = {
        datatab: '5594dgwAww8lrQppscvfDZCQlVXJ5lw+qpc4p4hMPOXTEij7IgI0JM53B5U', //对应表名
        pk: ids
      };
      await request
        .post('/server/delyznrup.php', params)
        .then((res) => {
          if (res.IsOk === 'success') {
            that.$message.success('恭喜，删除账号成功');
            that.getDoctorList();
          } else {
            that.$message.error('抱歉，删除账号失败');
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，删除账号失败');
        });
    },
    //取消
    cancelAddDoctor() {
      let that = this;
      that.patientForm.id = '';
      that.patientForm.name = '';
      that.patientForm.sex = '男';
      that.patientForm.phone = '';
      that.uploadImageSrc = '';
      that.hxFileList = [];
      that.$refs.patientForm.resetFields();
      that.visible = false;
    },
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 组件最大盒子
.member-content {
  width: 100%;
  height: 100%;
  // border: 2px solid palevioletred;
  display: flex;
  flex-direction: column;
}

.touxiang {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
}
.group {
  margin-top: 30px;
  margin-bottom: 10px;
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

.addPerson {
  cursor: pointer;
  padding: 10px 0;
  background: #f0e4ff;
  border-radius: 20px;
  margin-bottom: 23px;

  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }

  span {
    font-size: 16px;
    font-weight: bold;
    color: #8744e0;
  }
}

.personList {
  // flex: 1;
  height: calc(100vh - 515px);
  margin: auto;
  margin-top: 10px;
  overflow-y: auto;
  // border: 2px solid rgb(94, 255, 0);
  padding-bottom: 15px;
  box-sizing: border-box;

  .personList-item {
    padding: 5px 0 5px 10px;
    cursor: pointer;
    border-radius: 20px;
    background: #fff;

    &:hover {
      background-color: #f8f9fe;
    }

    img {
      width: 50px;
      height: 50px;
      margin-right: 7px;
    }

    .info {
      font-size: 15px;
      color: #333;
      font-weight: bold;
      margin-right: 15px;
      flex-grow: 1;
    }
  }
}
.el-form {
  width: 60%;
}
</style>
